import React, { useEffect,useState } from "react";
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';

function App() {

  const projects = [
    { id:0,
      name:'Event Calendar', 
      church:'Faithbridge Church - Spring, TX', 
      icon: 'fa fa-calendar',
      slides:[
        {id:0, image:'assets/1A.jpg', subtitle:'Calendar App',description:'This single page app displays calendar events in a variety of ways, while only fetching the data from the backend once on the initial page load.'},
        {id:1, image:'assets/1aa.jpg', subtitle:'Featured Events View', description:'The "Featured Events" view shows events that the church wants to highlight with a picture and short summary.'},
        {id:2, image:'assets/1B.jpg', subtitle:'Featured Event Detail', description:'Clicking on "More Details" will navigate the user to another page where they can read more about the event or register.'},
        {id:3, image:'assets/1C.jpg', subtitle:'Event Calendar View', description:'The "Event Calendar" view shows all events on the schedule, grouped by month.'},
        {id:4, image:'assets/1D.jpg', subtitle:'Event Calendar View', description:'If there are 5 or more events on the schedule for a certain day, a "See All Events" button appears.'},
        {id:5, image:'assets/1E.jpg', subtitle:'Event Calendar Modal', description:'Clicking on "See All Events" opens a modal showing all events for that day.'},
        {id:6, image:'assets/1F.jpg', subtitle:'Event Calendar Detail', description:'Clicking on any of the event names will take the user to the Event Detail page.'},
        {id:7, image:'assets/1G.jpg', subtitle:'Search View', description:'Typing in the search bar will display a third view, with events matching the search term.'},
        {id:8, image:'assets/1H.jpg', subtitle:'Audience Filter - Featured', description:'The audience dropdown will filter the results.'},
        {id:9, image:'assets/1I.jpg', subtitle:'Audience Filter - Full Calendar', description:'The user can filter the full calendar as well.'},
      ],
      website:'https://faithbridge.org/events/featured'
    },
    { id:1, 
      name:'Small Group Finder', 
      icon: 'fa fa-users',
      church:'Community Bible Church - San Antonio, TX', 
      slides:[
        {id:0, image:'assets/2A.jpg', subtitle:'Community Group Finder',description:'This single page app filters through hundreds of small groups to help the user find the right one for them.'},
        {id:1, image:'assets/2B.jpg', subtitle:'Filtering', description:'The app provides several filters. As the user scrolls through the cards, the filters stay available in the lefthand panel. Since all of the data is available on page load, filtering happens in an instant.'},
        {id:2, image:'assets/2C.jpg', subtitle:'Page Parameters', description:'Filter choices are also inserted into the URL as page parameters, allowing the user to share a link to the group finder that is prepopulated.'},
        {id:3, image:'assets/2D.jpg', subtitle:'Search Bar', description:'Users for a group by name or other attributes. The search bar can be used on its own, or in conjunction with filters.'},
        {id:4, image:'assets/2E.jpg', subtitle:'Group Detail', description:'Users click on a card to see more details about the group, along with a link to a page where they can join the group.'},
        {id:5, image:'assets/2F.jpg', subtitle:'Google Map View', description:'The app also embeds a dynamic map using the Google Map API. Users can scroll and zoom in to get better sense of the location. For the safety of group hosts, zoom is limited and the pins are not precise.'},
        {id:6, image:'assets/2G.jpg', subtitle:'Map Filtering', description:'The selected filters apply to the map and the cards similtaneously, and the search bar works the same way.'},
        {id:7, image:'assets/2I.jpg', subtitle:'Map Detail View', description:'Clicking on a map pin will show the name of the group, and clicking "More Info" will open the group detail modal.'}
      ],
      website:'https://communitybible.com/page/1593'
    },
    { id:2, 
      name:'Sermon Archive',
      icon: 'fa fa-play-circle',
      church:'The Woodlands Methodist Church - The Woodlands, TX', 
      slides:[
        {id:0, image:'assets/3A.jpg', subtitle:'Messages Page',description:'The Woodlands Methodist Church records 4-5 sermons every week between their multiple campuses and worship centers. As a result, they have an archive of nearly 2000 sermons and 400 series.'},
        {id:1, image:'assets/3B.jpg', subtitle:'Optimizing Load Time', description:'With the previous version of this site, there was a load time of up to 10 seconds. Rather than querying the database on every page load, I created a JSON dataset that refreshes the relevant data once an hour.'},
        {id:2, image:'assets/3C.jpg', subtitle:'Optimizing Load Time', description:'Now the page loads in a second or two, and the user can filter between campuses and service types in an instant.'},
        {id:3, image:'assets/3D.jpg', subtitle:'Sermon Detail Page', description:'The sermon detail pages were experiencing some of the worst load times. In the previous version, the "sermon-slug" page parameter was compared against 2000 content items to find the intended target.'},
        {id:4, image:'assets/3F.jpg', subtitle:'Sermon Detail Page', description:'Instead, I restructured the data into a normalized object. The page pulls in the slug from the page parameter, and uses the object to get the item id immediately. This has made browsing content much more user friendly.'}
      ],
      website:'https://thewoodlandsmethodist.org/messages'
    }
  ]
  const [selectedProject, setSelectedProject] = useState(projects[0]);
  const [currentSlide, setCurrentSlide] = useState(0);
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "ArrowLeft" && currentSlide > 0) {
        setCurrentSlide((prev) => prev - 1);
      } else if (event.key === "ArrowRight" && currentSlide < selectedProject.slides.length - 1) {
        setCurrentSlide((prev) => prev + 1);
      }
    };
    window.addEventListener("keydown", handleKeyDown);
  return () => window.removeEventListener("keydown", handleKeyDown);
}, [currentSlide,selectedProject]);

  return (
    <div className="App">
      <div className="header-background"></div>
      <div className="header-container">
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col-xs-12 col-md-9 col-lg-7">
              <div className="text-box">
                <div className="h1 header-text text-white" >Steve Husmann</div>
                <div className="h3 header-text text-white">software engineer building dynamic and beautiful user interfaces</div>
              </div>
            </div>
          </div>
          <a className="next-page-button text-white h3 header-text text-decoration-none d-flex flex-column align-items-center" href="#work">
            Featured Work
            <i className="fa fa-chevron-down"></i>
          </a>
      </div>
    </div>
      
    <div id="work" className="d-flex justify-content-start">
      <div id="work-bar" className="container-fluid d-flex flex-column flex-lg-row align-items-center justify-content-center">
        <div className="h3 header-text my-4 my-lg-0 me-lg-5" >Choose a Project</div>
        <div className="m-0 py-2 row" >
        {projects.map((project,index) => (
          <div className="col-4">
            <button
              key={project.id}
              onClick={() => {
                setSelectedProject(project);
                setCurrentSlide(0);
                }}
              className={`project-button ${selectedProject.id === projects[index].id ? "selected" : ""}`}
            >
              <div className="project-icon d-flex flex-column justify-content-center">
                <i className={project.icon}></i>
                {project.name}
              </div>
            </button>
          </div>
        ))}
        </div>
      </div>
      <div id="work-container" className="container-fluid px-0 ">
        <div className="container">
          <div id="site-info" className="text-center">
            <div className="h2 header-text mt-4 mt-lg-5">{selectedProject.name}</div>
            <div className="h4 header-text text-uppercase theme-2 my-2">{selectedProject.church}</div>
            <a href={selectedProject.website} target="_blank" className="btn btn-primary bg-theme-2 text-bold text-uppercase py-3 px-4 my-2" rel="noreferrer">Visit Page<i className="fa fa-external-link ms-3"></i></a>
          </div>
          <div id="slide-row" className="row d-flex align-items-center">
            <div className="col-12 col-lg-6 col-xl-7">
              <div className="position-relative w-100">
                {selectedProject.slides.map((slide) => (
                    <div
                    className={`desktop-view ${slide.id === currentSlide ? "current-slide" : ""}`} style={{backgroundImage: `url(${slide?.image})`}}
                    >
                    </div>
                ))}
              </div>

            </div>
            <div id="slide-container" className="col-12 col-lg-6 col-xl-5">
              <div className="container h-100">
                <div className="row">
                  <div className="col-12">
                    <div className="subtitle-container position-relative">
                    {selectedProject.slides.map((slide) => (
                        <div className="w-100 position-absolute">
                          <div
                          className={`header-text h4 m-0 w-100 text-uppercase text-center theme-2 slide-subtitle ${slide.id === currentSlide ? "current-slide" : ""}`}
                          >
                            {slide?.subtitle}
                          </div>
                        </div>
                        ))}
                    </div>
                  </div>
                </div>
                <div className="row d-flex flex-wrap align-items-center" id="slide-deck">
                  <div className="col-1 px-0">
                    {currentSlide > 0 && (
                      <button 
                      key="minus-slide"
                      className="slide-button"
                      onClick={() => setCurrentSlide(currentSlide - 1)}>
                        <i className="fa fa-chevron-left"></i>
                      </button>
                    )}
                  </div>
                  <div className="col-10 h-100">
                    <div id="slide-container" className="position-relative h-100">
                      {selectedProject.slides.map((slide) => (
                        <div
                        className={`header-text h5 slide ${slide.id === currentSlide ? "current-slide" : ""}`}
                        >
                          {slide?.description}
                        </div>
                        ))}
                      </div>
                  </div>
                  <div className="col-1 px-0">
                    {currentSlide + 1 < selectedProject.slides.length && (
                      <button 
                      key="plus-slide"
                      className="slide-button"
                      onClick={() => setCurrentSlide(currentSlide + 1)}>
                        <i className="fa fa-chevron-right"></i>
                      </button>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="d-flex flex-row justify-content-center align-items-center">
                    {selectedProject.slides.map((slide) => (
                      <button
                        key='{selectedProject.name}-slide-{slide.id}'
                        onClick={() => setCurrentSlide(slide.id)}
                        className={`fa ${slide.id === currentSlide ? "fa-circle" : "fa-circle-o"}`}
                      >
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  );
}

export default App;
